import { Dispatch, ForwardedRef, forwardRef, SetStateAction } from "react";

import { OrganisationPermissionConstants } from "../../../../../../constants";
import { GetInTouchData } from "../../../../../../models";
import { ActionButtons, Column, Row, Toggle } from "../../../../../../widget";
import { DeveloperMarketingAssetsFormChangedAction, DeveloperMarketingAssetsSubmitHandler } from "../../models";
import { useGetInTouchForm } from "./useGetInTouchForm";

interface GetInTouchProps {
  getInTouchDefaultValues: GetInTouchData;
  getInTouchOldDefaultValues: GetInTouchData;
  listingRowVersion: number;
  setListingRowVersion: Dispatch<SetStateAction<number>>;
  dispatch: Dispatch<DeveloperMarketingAssetsFormChangedAction>;
  getCurrentFormsData: (formWhichWasSaved: string) => string;
}

export const GetInTouchForm = forwardRef(
  (
    {
      getInTouchDefaultValues,
      getInTouchOldDefaultValues,
      listingRowVersion,
      setListingRowVersion,
      dispatch,
      getCurrentFormsData,
    }: GetInTouchProps,
    forwardedRef: ForwardedRef<DeveloperMarketingAssetsSubmitHandler>
  ): JSX.Element => {
    const { enabled, isHandleSubmitLoading, setEnabled, handleSubmit, handleCancel, hasPermission } = useGetInTouchForm(
      getInTouchDefaultValues,
      getInTouchOldDefaultValues,
      listingRowVersion,
      setListingRowVersion,
      dispatch,
      forwardedRef,
      getCurrentFormsData
    );

    return (
      <form onSubmit={(e) => handleSubmit(e)}>
        <Row spacingV="ll">
          <Column span={4}>
            <h2>Get in touch</h2>
          </Column>
        </Row>
        <Row spacingV="ll">
          <Column span={12}>
            <Toggle label="Show this section on organisation profile" value={enabled} onChange={setEnabled} />
          </Column>
        </Row>
        {hasPermission(OrganisationPermissionConstants.WRITE_ORGANISATION) && (
          <Row spacingV="2xl">
            <Column span={4}>
              <ActionButtons onCancel={handleCancel} isLoading={isHandleSubmitLoading} />
            </Column>
          </Row>
        )}
      </form>
    );
  }
);
